import React from 'react'
import { Card, Col, Placeholder, Row } from 'react-bootstrap'

const PurchasePlaceholder = () => {
    return (
        <>
            <Row className="p-5">
                <Col sm={12} md={6} lg={8}>
                    <p aria-hidden="true">
                        <Placeholder sm={12} md={6} lg={6} />
                    </p>
                    <p aria-hidden="true">
                        <Placeholder sm={12} md={10} lg={10} />
                    </p>
                    <Placeholder.Button xs={4} aria-hidden="true" />
                </Col>

                <Col sm={12} md={6} lg={4}>
                    <Card style={{ width: "100%" }}>
                        <Card.Body>
                            <Placeholder
                                as={Card.Subtitle}
                                animation="glow"
                                className="text-star    t"
                            >
                                <Placeholder xs={4} md={4} lg={4} />
                            </Placeholder>

                            <Placeholder
                                as={Card.Title}
                                animation="glow"
                                className="text-start mt-3"
                            >
                                <Placeholder xs={6} md={6} lg={6} />
                            </Placeholder>

                            <Placeholder
                                as={Card.Text}
                                animation="glow"
                                className="mt-5"
                            >
                                <Placeholder xs={12} md={12} lg={12} />
                                <Placeholder xs={12} md={12} lg={12} />
                                <Placeholder xs={12} md={12} lg={12} />
                                <Placeholder xs={12} md={12} lg={12} />
                                <Placeholder xs={12} md={12} lg={12} />
                                <Placeholder xs={12} md={12} lg={12} />
                                <Placeholder xs={12} md={12} lg={12} />
                                <Placeholder xs={12} md={12} lg={12} />
                                <Placeholder xs={12} md={12} lg={12} />
                                <Placeholder xs={12} md={12} lg={12} />
                                <Placeholder xs={12} md={12} lg={12} />
                                <Placeholder xs={12} md={12} lg={12} />
                                <Placeholder xs={12} md={12} lg={12} />
                                <Placeholder xs={12} md={12} lg={12} />
                                <Placeholder xs={12} md={12} lg={12} />
                                <Placeholder xs={12} md={12} lg={12} />
                            </Placeholder>

                            <Placeholder.Button
                                variant="primary"
                                xs={12}
                                md={12}
                                lg={12}
                                className="text-center"
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

        </>
    )
}

export default PurchasePlaceholder